/* eslint-disable */
require('./activities');
require('./auto-loan-transportation');
require('./cable-internet');
require('./charity');
require('./child-care');
require('./clothing');
require('./continue-education');
require('./dining-out');
require('./electricity');
require('./furniture');
require('./gas');
require('./grocery');
require('./home-improvements');
require('./housing');
require('./insurance');
require('./investments');
require('./mortgage-loan');
require('./pet-care');
require('./placeholder1');
require('./placeholder2');
require('./placeholder3');
require('./savings');
require('./school-expenses');
require('./self-care');
require('./transportation');
require('./vacation');
require('./water-trash');
require('./car-bank');
require('./car-dealership');
